import api from './api'

export const getAdminUsers = async () => {
    try{
        const response = await api.get(`/admin/users/get_users`);
        return response.data
    }
    catch(error){
        console.error(error)
    }
}


export const getAdminRoles = async () => {
    try{
        const response = await api.get(`/roles/get_admin_roles`);
        return response
    }
    catch(error){
        console.error(error)
    }
}


export const createRole = async (payload) => {
    try{
        const response = await api.post(`/roles/create_role`,payload);
        return response
    }
    catch(error){
        console.error(error)
    }
}

export const editRole = async (id,payload) => {
    try{
        const response = await api.put(`/roles/edit_role/${id}`,payload);
        return response
    }
    catch(error){
        console.error(error)
    }
}

export const createAdminUsers = async (payload) => {
    try{
        const response = await api.post(`/admin/users/create_user`,payload);
        return response.data
    }
    catch(error){
        // console.error(error)
       throw new Error(error.response?.data?.detail)
    }
}

export const createSuperAdmin = async (payload) => {
    try{
        const response = await api.post(`/admin/users/create_admin_user`,payload);
        return response.data
    }
    catch(error){
       throw new Error(error)
    }
}

export const editSuperAdmin = async (payload) => {
    try{
        const response = await api.put(`/admin/users/edit_user`,payload);
        return response.data
    }
    catch(error){
       throw new Error(error)
    }
}


export const editAdminUser = async (payload) => {
    try{
        const response = await api.put(`/admin/users/edit_user`,payload);
        return response.data
    }
    catch(error){
       throw new Error(error)
    }
}
export const deactivateUser= async (payload) => {
    try{
        const response = await api.put(`/admin/users/deactivate_user/`,payload);
        return response.data
    }
    catch(error){
       throw new Error(error)
    }
}

export const deactivateRole = async (id) => {
    try{
        const response = await api.put(`/roles/deactivate_role/${id}`);
        return response.data
    }
    catch(error){
       throw new Error(error)
    }
}



export const getAdminTabs = async () => {
    try{
        const response = await api.get('/admin/users/admin_tabs/');
        return response.data
    }
    catch(error){
       throw new Error(error)
    }
}


export const getAdminUserForTable = async (payload) => {
    try{
        const response = await api.post('/admin/users/get_admin_for_table/',payload);
        return response.data
    }
    catch(error){
       throw new Error(error)
    }
}
